import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";

const BGColor = [ '#00BFFF', '#32CD32', '#FFC107', '#DC143C', '#FFDAB9', '#40E0D0', '#FFA07A', '#0027ED', '#F6FF00', '#FF69B4'];
const borderColor = [ '#00BFFF', '#32CD32', '#FFC107', '#DC143C', '#FFDAB9', '#40E0D0', '#FFA07A', '#0027ED', '#F6FF00', '#FF69B4'];

const DonutWidget = ({ chartData }) => {
  const [chartData2, setChartData2] = useState({
    labels: [],
    datasets: [
      { data: [], backgroundColor: [], borderColor: [], borderWidth: 1 },
    ],
  });

  useEffect(() => {
    if (chartData) {
      if (chartData?.properties.length > 0) {
        let labels = chartData?.properties?.map((i) => i?.title);
        let cdata = chartData?.properties?.map((i) => i?.total);
        let bg = chartData?.properties?.map((_, i) => BGColor[i]);
        let border = chartData?.properties?.map((_, i) => borderColor[i]);

        setChartData2({
          labels: labels,
          datasets: [
            {
              data: cdata,
              backgroundColor: bg,
              borderColor: border,
              borderWidth: 1,
            },
          ],
        });

        console.log(labels);
      }
    }
  }, [chartData]);

  const options = {
    legend: {
      display: false,
    },
    tooltip: {
      display: false,
    },
    maintainAspectRatio: false,
    cutoutPercentage: 75,
    responsive: true,
  };

  return <Doughnut data={chartData2} options={options} />;
};

export default DonutWidget;
